// Default Button
import styled from "styled-components";

export default styled.button`
  outline: none;
  opacity: ${(props) => (props.isDisabled ? 0.3 : 1)};
  cursor: ${(props) => (props.isDisabled ? "default" : "pointer")};
  background-color: transparent;
`;
